// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required_border[data-v-3cf6de24]{border:1px solid var(--v-error-base)!important}.required_label[data-v-3cf6de24]{font-weight:700;margin-left:-10px;margin-top:-33px;position:absolute;text-transform:uppercase}.required_label.v-chip.v-chip.v-chip--outline[data-v-3cf6de24]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
